<template>
  <div class="don">
    <BreadsCrums page="don" previous="home" />
    <section class="our-mission">
      <div class="container">
        <div class="box-mission text-center">
          <div class="garden-title">
            <h3>Donations</h3>
          </div>
          <p>{{ $t("donText") }}</p>
          <p>{{ $t("merciDon") }}</p>
        </div>
      </div>
      <div class="box">
        <img
          src="https://res.cloudinary.com/yanfomaweb/image/upload/v1551657595/afrikeveil/Screen_Shot_2019-03-04_at_00.56.10.png"
          alt
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  created() {
    document.title = this.$i18n.t("navBar.don");
  },
  name: "Don"
};
</script>
<style scoped>
@media (max-width: 767px) {
  .our-mission {
    margin-top: -250px !important;
    padding-top: 50px;
  }
}
</style>
